import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';

const requrest = (url, method = 'POST', data = {}, params) => {
  return API.request({
    method,
    url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data,
    params,
  });
};

const getData = (declarationId) => {
  return requrest(`/notification/${NDFL3_NOTIFICATION_ID}/view/${declarationId}`, 'GET');
};

/**
 * Create and send specified declaration
 * @param {Number} declarationId
 * @param {Number} mode - creation mode
 */
const copy = (declarationId, mode) => {
  return requrest(
    `/notification/${NDFL3_NOTIFICATION_ID}/view/${declarationId}/refine`,
    'PUT',
    null,
    { mode },
  );
};

/**
 * Edit declaration and re-send
 * @param {Number} declarationId
 */
const reSend = (declarationId) => {
  return requrest(`/notification/${NDFL3_NOTIFICATION_ID}/view/${declarationId}/edit`, 'PUT');
};

/**
 * Create inventory xml for attaches (without declaration xml)
 * @param {Number} declarationId
 * @param {Object} data
 * @param {String} queryParams
 */
const createInventory = (declarationId, data, queryParams = '') => {
  return requrest(
    `/notification/${NDFL3_NOTIFICATION_ID}/view/${declarationId}/xml`,
    'POST',
    data,
    queryParams,
  );
};

/**
 * Send attachments with xml inventory without declaration itself
 * @param {Object} data
 */
const sendAttachments = (data) => {
  return requrest(`/notification/${NDFL3_NOTIFICATION_ID}/view/attach`, 'POST', data);
};

export { getData, copy, reSend, createInventory, sendAttachments };
